import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { hasSavedLocale, i18n, setLocale } from './i18n';
import { platform } from './platform';
import { useSessionStore } from './stores/session';
import './styles/tokens.css';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);

platform.ready();
// First launch: follow the Telegram/browser language; after that the choice
// made in Profile is kept.
if (!hasSavedLocale()) setLocale(platform.preferredLanguage()?.startsWith('ru') ? 'ru' : 'en');

const session = useSessionStore(pinia);
session.init().then(() => {
  const start = platform.startRoute();
  if (start) router.replace(start);
});

app.mount('#app');
